import {ReactNode} from "react";

type CodePreviewProps = {
    children: ReactNode;
    className?: string;
};

const CodePreview = ({ children, className }: CodePreviewProps) => {
    return (
        <div className={`snippet-preview p-4${className ? ` ${className}` : ""}`}>
            {children}
        </div>
    );
}
export default CodePreview;




